import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from "@/Components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import axiosInstance from '../utils/axiosConfig';

const VerifyEmail = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [verificationStatus, setVerificationStatus] = useState('verifying'); // 'verifying', 'success', 'error'
    const [errorMessage, setErrorMessage] = useState('');
    //

    useEffect(() => {
        const verifyEmail = async () => {
            try {
                const response = await axiosInstance.post('/auth/verify-email', { token });
                if (response.data.success) {
                    setVerificationStatus('success');  
                } else {
                    setVerificationStatus('error');
                    setErrorMessage(response.data.error);
                }
            } catch (error) {
                console.error('Verification error:', error);
                setVerificationStatus('error');
                if (error.response?.data?.error) {
                    setErrorMessage(error.response.data.error);
                } else {
                    setErrorMessage('Er is een fout opgetreden bij het verifieren van je e-mailadres.');
                }
            }
        };

        if (token) {
            verifyEmail();
        } else {
            setVerificationStatus('error');
            setErrorMessage('Geen verificatie token gevonden.');
        }
    }, [token]);

    const getContent = () => {
        switch (verificationStatus) {
            case 'verifying':
                return (
                    <div className="text-center">
                        <Loader2 className="h-12 w-12 animate-spin text-ps-blue-dark mx-auto mb-4" />
                        <h2 className="text-2xl font-inter text-ps-blue-dark mb-2">
                            E-mailadres verifieren
                        </h2>
                        <p className="text-gray-600 font-inter">
                            Een moment geduld terwijl we je e-mailadres verifieren...
                        </p>
                    </div>
                );

            case 'success':
                return (
                    <div className="text-center">
                        <CheckCircle2 className="h-12 w-12 text-green-500 mx-auto mb-4" />
                        <h2 className="text-2xl font-inter text-ps-blue-dark mb-2">
                            E-mailadres geverifieerd!
                        </h2>
                        <p className="text-gray-600 font-inter mb-6">
                            Je e-mailadres is succesvol geverifieerd.<br /><br />Wanneer je je hebt aangemeld bij een bestaand bedrijf moet de beheerder u eerst toestemming geven, anders kunt nu inloggen op je account.
                        </p>
                        <Button
                            onClick={() => navigate('/')}
                            className="bg-ps-blue-dark hover:bg-ps-blue-dark/90 text-white font-inter"
                        >
                            Ga naar inloggen
                        </Button>
                    </div>
                );

            case 'error':
                return (
                    <div className="text-center">
                        <XCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
                        <h2 className="text-2xl font-inter text-ps-blue-dark mb-2">
                            Verificatie mislukt
                        </h2>
                        <p className="text-red-600 font-inter mb-6">
                            {errorMessage}
                        </p>
                        <div className="space-y-4">
                            <Button
                                onClick={() => navigate('/')}
                                className="bg-ps-blue-dark hover:bg-ps-blue-dark/90 text-white font-inter"
                            >
                                Ga naar inloggen
                            </Button>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12">
            <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-lg">
                {getContent()}
            </div>
        </div>
    );
};

export default VerifyEmail;